"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamGraphService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var TeamGraphService = /** @class */ (function () {
    function TeamGraphService() {
    }
    /**
     * Get Similar Builders
     * Get similar builders for the uids
     * @param uids List of builder ids to find similar builders to
     * @returns SimilarBuildersResponse Success
     * @throws ApiError
     */
    TeamGraphService.getSimilarBuilders = function (uids) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/builders/similarity',
            query: {
                'uids': uids,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return TeamGraphService;
}());
exports.TeamGraphService = TeamGraphService;
//# sourceMappingURL=TeamGraphService.js.map